// mostly taken from https://github.com/Giphy/giphy-js/tree/master/packages/types/src
import type { EditorPluginConfig, ViewerPluginConfig } from './../ricos-types';

export const GIPHY_TYPE = 'wix-draft-plugin-giphy';

export interface GiphyPluginEditorConfig extends EditorPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  getGiphyUrl?: (path: 'search' | 'trending') => string | undefined;
  /* @deprecated use getGiphyUrl if you need to override our giphy proxy. This does nothing */
  giphySdkApiKey?: string;
}
export interface GiphyPluginViewerConfig extends ViewerPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export interface ResultMeta {
  msg: string;
  response_id: string;
  status: number;
}
export interface ResultPagination {
  count: number;
  total_count: number;
  offset: number;
}
interface Result {
  meta: ResultMeta;
  pagination: ResultPagination;
}
export interface GifsResult extends Result {
  data: IGif[];
}
export interface ICategory {
  gif?: IGif;
  name: string;
  name_encoded: string;
  subcategories: ICategory[];
}

export interface IGif {
  type: 'video' | 'gif' | 'text' | 'sticker';
  id: string | number;
  tabOrder?: number;
  slug: string;
  url: string;
  bitly_gif_url: string;
  bitly_url: string;
  embed_url: string;
  username: string;
  source: string;
  rating: string;
  content_url: string;
  source_tld: string;
  source_post_url: string;
  is_indexable?: boolean;
  is_sticker: number;
  import_datetime: string;
  trending_datetime: string;
  images: IImages;
  title: string;
  is_hidden?: boolean;
  is_scheduled?: boolean;
  is_removed?: boolean;
  tags?: string[];
  analytics_response_payload: string;
  emoji_group_id?: number;
  variation?: string;
  variation_count?: number;
  alt_text?: string;
  user?: {
    avatar_url: string;
    banner_image: string;
    banner_url: string;
    profile_url: string;
    username: string;
    display_name: string;
    description: string;
    instagram_url: string;
    website_url: string;
    is_verified: boolean;
  };
  analytics: {
    onload: {
      url: string;
    };
    onclick: {
      url: string;
    };
    onsent: {
      url: string;
    };
  };
}

interface IRendition {
  width: number | string;
  height: number | string;
}
export interface IImage extends IRendition {
  url: string;
  size?: string;
  frames?: string;
  hash?: string;
  mp4_size?: string;
  mp4?: string;
}
export interface IMP4 extends IRendition {
  mp4: string;
  mp4_size: string;
}
export interface IWebP {
  webp: string;
  webp_size: string;
}

export type ImageAllTypes = IImage & Partial<IWebP> & Partial<IMP4>;

export interface IImages {
  fixed_height_still: IImage;
  original_still: IImage;
  fixed_width: ImageAllTypes;
  fixed_height_small_still: IImage;
  fixed_height_downsampled: IImage & IWebP;
  preview: IMP4;
  fixed_height_small: ImageAllTypes;
  downsized_still: IImage;
  downsized: IImage;
  downsized_large: IImage;
  fixed_width_small_still: IImage;
  preview_webp: IImage;
  fixed_width_still: IImage;
  fixed_width_small: ImageAllTypes;
  downsized_small: IMP4;
  fixed_width_downsampled: IImage & IWebP;
  downsized_medium: IImage;
  original: ImageAllTypes;
  fixed_height: ImageAllTypes;
  looping: Partial<IMP4>;
  original_mp4: IMP4;
  preview_gif: IImage;
  '480w_still': IImage;
  hd?: IMP4;
}
